import { LicenseInfo, withSBErrorHandling } from '../types';
import { ScanbotBarcodeSDKPlugin } from './definitions';
/**
 * @internal
 * @hidden
 */
export const ScanbotBarcodeSdkImpl = {
    initialize(config) {
        return withSBErrorHandling(async () => new LicenseInfo(await ScanbotBarcodeSDKPlugin.initialize(config)));
    },
    getLicenseInfo() {
        return withSBErrorHandling(async () => new LicenseInfo(await ScanbotBarcodeSDKPlugin.getLicenseInfo()));
    },
    cleanupStorage() {
        return withSBErrorHandling(ScanbotBarcodeSDKPlugin.cleanupStorage);
    },
    mockCamera(params) {
        return withSBErrorHandling(() => ScanbotBarcodeSDKPlugin.mockCamera(params));
    },
};
//# sourceMappingURL=SdkImpl.js.map